export const LEGAL_TERMS_OF_USE_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Terms Of Use</h1>
 Terms and Conditions Overview
</center>

---

## Terms Of Use

*Also Referred to as “Allgemeine Geschäftsbedingungen (abgekürzt AGB)” in German Law*
*Effective as November 19, 2024, and Last updated November 19, 2024*
`;
